module.exports = __webpack_public_path__ + "img/Large-Horizontal-Rectangular-Attachment-22.61299dcc.png";